import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Button, Text } from "@chakra-ui/react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { UserInfo } from "../types";

type NotificationModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function NotificationModal({ isOpen, onClose }: NotificationModalProps) {
  const authUser = useAuthUser() as UserInfo | null;
  const [whatsAppUrl, setWhatsAppUrl] = useState<string>("");

  useEffect(() => {
    if (!authUser) return;
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER || "";
    const message = encodeURIComponent(
      `Hi, I'm ${authUser.firstName} ${authUser.lastName} (${authUser.username}). Could you please send me my weekly report?`
    );
    if (phoneNumber) {
      setWhatsAppUrl(`https://wa.me/${phoneNumber}?text=${message}`);
    }
  }, [authUser]);

  function handleWhatsAppClick() {
    if (!whatsAppUrl) return;
    window.open(whatsAppUrl, "_blank");
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Weekly summary</ModalHeader>
        <ModalBody pb={6}>
          <Text mb={4}>
            Thanks for using Pick and Price this week. You can request your detailed weekly report via WhatsApp.
          </Text>
          <Button colorScheme="teal" width="100%" mb={3} onClick={handleWhatsAppClick} isDisabled={!whatsAppUrl}>
            WhatsApp me my report
          </Button>
          <Button variant="ghost" width="100%" onClick={onClose}>
            Close
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

